export const formatModeofInheritance = (unformattedText) => {
  const hasDash = unformattedText.includes("-");
  const hasQuestionMark = unformattedText.includes("?");
  const formattedText = unformattedText
    .split(" ")
    .map((item, i) => {
      if (i === 0) {
        if (hasQuestionMark) {
          return item.slice(0, 2);
        }
        if (hasDash) {
          return item.slice(item.indexOf("-", 0) - 1, 3);
        }
        return item.charAt(0);
      }
      return item.charAt(0);
    })
    .join("")
    .toUpperCase();
  return formattedText;
};
